module.exports = __webpack_public_path__ + "img/dark-mud-decal-20.7ebcc7ec.png";